import type { DataCollBlockedStatus } from './types';

/**
 * Check if data editing operations are allowed (diff resolution, table editing)
 *
 * Returns true if:
 * - Table is not blocked
 * - Current user is the one who blocked it
 * - Table is blocked but allow_data_editing is true (allows data edits by others)
 *
 * Use this for data-only operations like resolving diffs or editing cell values.
 * For structural operations (uploads, structural merges), use `isEditable` instead.
 */
export const isDataEditable = (
  dataCollBlockedStatus: DataCollBlockedStatus | undefined
): boolean => {
  if (!dataCollBlockedStatus?.isBlocked) return true;
  if (dataCollBlockedStatus?.blocking_user_is_current_user) return true;
  if (dataCollBlockedStatus?.allow_data_editing) return true;
  return false;
};

/**
 * Check if structural editing operations are allowed (uploads, structural merges)
 *
 * Returns true if:
 * - Table is not blocked
 * - Current user is the one who blocked it
 *
 * Use this for structural operations that modify table schema or structure.
 * For data-only operations, use `isDataEditable` instead.
 */
export const isEditable = (dataCollBlockedStatus: DataCollBlockedStatus | undefined): boolean => {
  return !dataCollBlockedStatus?.isBlocked || dataCollBlockedStatus?.blocking_user_is_current_user;
};
